// Import mutations
import { GET_TRAININGS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_TRAININGS] (state, trainings) {
    state.all = trainings
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/trainings.js